<template>
  <div class="modal-send d-flex flex-column justify-content-center align-items-center">
    <div class="close-btn" @click="$root.hideSend()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
      >
        <path
          d="M20 2.60225L18.2611 0.874268L10 9.0834L1.73892 0.874268L0 2.60225L8.26108 10.8114L0 19.0205L1.73892 20.7485L10 12.5394L18.2611 20.7485L20 19.0205L11.7389 10.8114L20 2.60225Z"
          fill="#000000"
        />
      </svg>
    </div>
    <h2 class="ttl">Отправить резюме</h2>
    <div class="modal-form">
      <b-form-group
        class="d-flex align-items-end"
        label="ФИО*"
        label-for="input-fio"
        id="input-fio-group"
      >
        <b-form-input
          oninput="this.value = this.value.replace(/[^ \a-zA-Zа-яA-Я]/g, '')"
          id="input-fio"
          v-model.trim="fio"
          placeholder="Введите имя*"
          @input="$v.fio.$touch()"
          @blur="checkError($v.fio, 'fio')"
          @focus="$v.fio.$touch()"
          autocomplete="off"
        ></b-form-input>
        <div class="error-pop" v-if="fioError !== ''">{{fioError}}</div>
      </b-form-group>
      <b-form-group class="d-flex align-items-end" label="Телефон*" label-for="input-tel">
        <b-form-input
          autocomplete="off"
          placeholder="+7("
          id="input-tel"
          v-model.trim="tel"
          @input="$v.tel.$touch()"
          @focus="$v.tel.$touch()"
          @blur="checkError($v.tel, 'tel')"
        ></b-form-input>
        <div class="error-pop" v-if="telError !== ''">{{telError}}</div>
      </b-form-group>
      <b-form-group>
        <label class="file" button for="file-input">
          <svg
            class="mr-2"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="none"
          >
            <path
              d="M13.577 6.09185L8.98753 1.53204C6.93151 -0.510681 3.59804 -0.510681 1.54202 1.53204C-0.514005 3.57477 -0.514005 6.88668 1.54202 8.92941L7.55105 14.8996C9.02395 16.363 11.4106 16.3674 12.889 14.9094C14.3626 13.4562 14.3714 11.0912 12.9087 9.62716C12.9055 9.62388 10.894 7.62538 6.87424 3.63166C5.98536 2.74852 4.54418 2.74852 3.6553 3.63166C2.76641 4.5148 2.76641 5.94665 3.6553 6.82979L8.24479 11.3896L9.37186 10.2698L4.78239 5.71C4.51597 5.4453 4.51597 5.01615 4.78239 4.75145C5.0488 4.48676 5.48075 4.48676 5.74717 4.75145L11.7718 10.7371C12.62 11.5861 12.6149 12.9484 11.7661 13.7855C10.9109 14.6289 9.53021 14.6263 8.67814 13.7798L2.66911 7.80961C1.23556 6.38533 1.23556 4.07612 2.66911 2.65184C4.10265 1.22756 6.4269 1.22756 7.86045 2.65184L12.4499 7.21164L13.577 6.09185Z"
              fill="#CCCCCC"
            />
          </svg>
          {{ file != null ? file.name :'Прикрепить файл' }}
        </label>
        <b-form-file
          id="file-input"
          name="file"
          class="file-input"
          v-model="file"
          :state="Boolean(file)"
          drop-placeholder="Drop file here..."
          plain
        ></b-form-file>
      </b-form-group>

      <p class="rules">
        Файл должен быть формата: pdf, doc, jpeg
        и не более 5 мб.
      </p>

      <button class="modal-button" :disabled="btndisable" @click="formSend()">Оставить заявку</button>
      <div class="modal-confident">
        <p>
          Нажимая на кнопку, Вы соглашаетесь
          с
          <a
            :href="$root.politconf"
          >политикой конфиденциальности</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Inputmask from "inputmask";
import { required, minLength } from "vuelidate/lib/validators";
const axios = require("axios");

export default {
  props: {
    vacancy: String
  },
  data() {
    return {
      fio: "",
      tel: "+7(",
      fioError: "",
      telError: "",
      visible: false,
      file: null,

      validFileExtensions: [
        "application/pdf",
        "application/msword",
        "image/jpeg",
        "image/pjpeg"
      ],
      errorMsg: false
    };
  },
  mounted() {
    var im = new Inputmask("+7(999)999-99-99", {
      positionCaretOnClick: "radixFocus",
      placeholder: "",
      greedy: false
    });
    im.mask(document.getElementById("input-tel"));
  },
  validations: {
    fio: {
      required,
      minLength: minLength(4)
    },
    tel: {
      required,
      minLength: minLength(16)
    }
  },
  methods: {
    checkError(err, name) {
      if (err.$error) {
        switch (name) {
          case "fio":
            if (!err.required) {
              this.fioError = "Это поле должно быть обязательно";
            } else if (!err.minLength) {
              this.fioError = "Это поле не должно быть короче 4 символов";
            }
            break;
          case "tel":
            if (!err.required) {
              this.telError = "Это поле должно быть обязательно";
            } else if (!err.minLength) {
              this.telError = "Введите номер в формате +7(ххх)ххх-хх-хх";
            }
            break;
        }
      } else {
        switch (name) {
          case "fio":
            this.fioError = "";
            break;
          case "tel":
            this.telError = "";
            break;
        }
      }
    },
    toggle() {
      this.visible = !this.visible;
      this.error1 = false;
      this.error2 = false;
      this.error3 = false;
    },
    select(option) {
      this.value = option;
    },
    formSend() {
      let this_comp = this;
      const formData = new FormData();
      formData.append("act", "vacancy-form");
      formData.append("fio", this.fio);
      formData.append("phone", this.tel);
      formData.append("vacancy", this.vacancy);
      formData.append("file", this.file);

      axios
        .post(`${this_comp.$root.routLink}/ajax/?ajax&act=fileUpload`, formData)
        .then(function(response) {
          formData.append("filelink", response.data.file);
        })
        .catch(function(error) {})
        .finally(function() {
          axios
            .post(`${this_comp.$root.routLink}/ajax/?ajax&act=form`, formData)
            .then(function(response) {
              this_comp.$root.showSuc();

              this_comp.$root.hideSend();
              this_comp.$root.hideVacant();

              this_comp.file = null;
              this_comp.fio = "";
              this_comp.phone = "+7(";
            })
            .catch(function(error) {})
            .finally(function() {});
        });
    }
  },
  computed: {
    btndisable() {
      if (this.fioError !== "" || this.telError !== "" || this.file == null) {
        return true;
      }
      return false;
    }
  },
  watch: {
    fio: function(val) {
      this.fio = val.replace(/[^ \a-zA-Zа-яA-Я]/g, "");
    },
    file(val) {
      this.errorMsg = false;
      let blnValid = false;
      for (let j = 0; j < this.validFileExtensions.length; j++) {
        let sCurExtension = this.validFileExtensions[j];

        if (val.size / 1024 / 1024 > 5) {
          this.errorMsg = "Размер файла больше 5MB";
          return;
        } else if (val.type == sCurExtension) {
          this.errorMsg = false;
          return;
        } else {
          this.errorMsg = "неверный формат файла";
        }
      }
      return;
    }
  }
};
</script>

<style lang="scss">
.modal-send {
  background: #ffffff;
  border-radius: 10px;
  padding: 0 75px;
  height: 533px;
  @media only screen and (max-width: $sm),
    only screen and (max-device-width: $sm) {
    padding: 0 15px;
  }

  .ttl {
    font-weight: 700;
    font-size: 30px;
    line-height: 115%;
    color: #000000;
    margin-bottom: 25px;
    @media only screen and (max-width: $sm),
      only screen and (max-device-width: $sm) {
    }
  }

  .modal-form {
    .form-group {
      width: 100%;
      height: 50px;
      position: relative;
      border: 1px solid #cccccc;
      border-radius: 6px;
      margin-bottom: 10px;
      @media only screen and (max-width: $sm),
        only screen and (max-device-width: $sm) {
        margin-bottom: 10px;
      }

      label {
        position: absolute;
        top: 10px;
        left: 10px;
        font-weight: 600;
        font-size: 10px;
        text-transform: uppercase;
        color: #cccccc;
        line-height: 1;

        &.file {
          color: #000000;
          position: relative;
          margin-bottom: 0;
          text-transform: none;
          font-size: 14px;
          font-weight: 500;
        }
      }

      div:not(.error-pop) {
        width: 100%;
        height: calc(100% - 25px);

        input {
          width: 100%;
          height: 100%;
          background-color: transparent;
          border: none;
          font-weight: 500;
          font-size: 12px;
          line-height: 1;
          color: #000000;
          padding-top: 0;
          padding-bottom: 10px;

          &:focus {
            outline: none;
            box-shadow: none;
          }

          &::-webkit-input-placeholder {
            font-weight: 500;
            font-size: 12px;
            line-height: 100%;
            color: #000000;
          }
        }
      }

      .error-pop {
        background: #ffffff;
        filter: drop-shadow(0px 0px 4px #cccccc);
        border-radius: 6px;
        height: 56px;
        padding: 0px 11px;
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        transform: translateY(-100%);
        font-weight: 600;
        font-size: 12px;
        line-height: 100%;
        color: $activeColor;

        &::after {
          content: url("data:image/svg+xml;charset=utf8,%3Csvg width='17' height='12' viewBox='0 0 17 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.5 11.9999L0.272759 0.749939L16.7272 0.749939L8.5 11.9999Z' fill='white'/%3E%3C/svg%3E");
          position: absolute;
          bottom: -13px;
        }
      }
    }

    .modal-button {
      width: 100%;
      height: 45px;
      background: $activeColor;
      border-radius: 6px;
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      color: $defaultColor;
      border: 2px solid $activeColor;
      outline: none;
      transition: all 0.5s ease-in-out;
      &[disabled] {
        background: #d3a9a7;
        border-radius: 6px;
        color: #8b5253;
        border: 2px solid #d3a9a7;
      }
      @media only screen and (max-width: $md),
        only screen and (max-device-width: $md) {
        width: 100%;
        margin-bottom: 10px;
      }

      &:not([disabled]):hover {
        background-color: $defaultColor;
        color: $activeColor;
      }
    }

    .modal-confident {
      height: 45px;
      width: 100%;
      font-weight: 500;
      font-size: 14px;
      line-height: 138%;
      display: flex;
      align-items: center;
      color: #7b7b7b;

      p {
        @media only screen and (max-width: $md),
          only screen and (max-device-width: $md) {
          text-align: center;
          height: 100%;
        }
      }

      a {
        color: #7b7b7b;
        text-decoration: underline;
      }
    }

    .rules {
      font-size: 14px;
      line-height: 132%;
      color: #7b7b7b;
      margin-bottom: 10px;
    }
  }

  .close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }

  .file-input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    padding: 0 !important;
  }
}
</style>